import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { EnforcementNoticeSearchState } from "./EnforcementNoticeSearchState";
import "../Search.css";
import { EnforcementNoticeFilter } from "@shared/publicportal/contracts/EnforcementNoticeFilter";

interface NoticeSimpleSearchProps {
    state: EnforcementNoticeSearchState;
    setter: (modifier: Partial<EnforcementNoticeFilter>) => void;
}

const EnforcementNoticeSimpleSearch: React.FC<NoticeSimpleSearchProps> = (props) => {
    return (
        <Grid container className="search-container search-container-simple">
            <Grid item xs={12} md={12} xl={12}>
                <Typography variant="h5">Reference</Typography>
            </Grid>
            <Grid item xs={12} md={12} xl={12}>
                <TextField
                    name="noticeRef"
                    value={props.state.filter.noticeRef}
                    onChange={(event) => props.setter({ noticeRef: event.target.value })}
                    key="enforcement-Notice-Reference-key"
                    size="small"
                    id="enforcement-Notice-Reference"
                    label="Notice Reference"
                    variant="outlined"
                    className="min-width-18rem"
                />
            </Grid>
        </Grid>
    );
};

export default EnforcementNoticeSimpleSearch;
